// socketClient.js

import { io } from "socket.io-client";
import { getBranchCode, getCompanyCode, getLicenseeCode } from "./GetUserInfo";
// const SOCKET_SERVER_URL = "http://ec2-15-206-81-66.ap-south-1.compute.amazonaws.com:4000"; //Server URL

const path = window.location.href;
const licenseeCode = await getLicenseeCode();
const CompanyCode = await getCompanyCode();
const BranchCode = await getBranchCode();

let SOCKET_SERVER_URL = "";

if (path.includes(licenseeCode) && path.includes(CompanyCode?.CompanyCode) && path.includes(BranchCode?.BranchCode)) {
  SOCKET_SERVER_URL = process.env.REACT_APP_API_URL;
} else {
  SOCKET_SERVER_URL = process.env.REACT_APP_CUSTOMER_SITE_BACKEND;
}

console.log(SOCKET_SERVER_URL, licenseeCode, "const path = window.location.pathname;");

const socket = {}; // io(SOCKET_SERVER_URL);

export const emtSocket = {}; // io(SOCKET_SERVER_URL);
export default socket;
